; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('SageDotCom/Components/ProductsCollectionComponent',['eventManager', 'moduleLoader', 'jquery', 'jsCookie', 'knockout', 'SageDotCom/Utility/gatedContentHelper', 'sbcExtProductsService', 'shoppingCartService', 'koLoadUXModule', 'koBsTooltip', 'MiniCartBuyButton', 'SageDotCom/DataLayer/tealium', 'SageDotCom/DataLayer/Events/bodySelect', 'MiniCartModal'], factory) :
        typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require('eventManager'), require('moduleLoader'), require("jquery"), require('SageDotCom/Utility/gatedContentHelper'), require('jsCookie'), require('knockout'), require('sbcExtProductsService'), require('shoppingCartService'), require('koLoadUXModule'), require('koBsTooltip'), require('MiniCartBuyButton'), require('SageDotCom/DataLayer/tealium'), require('SageDotCom/DataLayer/Events/bodySelect'), require('MiniCartModal')) :
    console && console.error('ProductsCollectionComponent loaded in a wrong way');
}(this/* window */, function (eventManager, moduleLoader, $, jsCookie, ko, gatedContentHelper, productsServiceCtor, shoppingCartService, koLoadUXModule, koBsTooltip, miniCartBuyButton, tealium, bodySelectEvent, miniCartModal) {

    function ProductsCollectionComponent(scope, personaId, extProdApiDomain, extProdApiKey, marketId, langName) {
        
        Object.defineProperty(this, 'scope', { enumerable: !0, value: scope, configurable: !0, writable: !1 });
        Object.defineProperty(this, 'personaId', { enumerable: !0, value: personaId, configurable: !0, writable: !1 });
        Object.defineProperty(this, 'extProdApiDomain', { enumerable: !0, value: extProdApiDomain, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'extProdApiKey', { enumerable: !0, value: extProdApiKey, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'marketId', { enumerable: !0, value: marketId, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'langName', { enumerable: !0, value: langName, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'products', {enumerable: !0, value: ko.observableArray([]), configurable: !0, writable: !1 });
        Object.defineProperty(this, '$modalPopup', {enumerable:!1, value: this._prepareModalPopup(), configurable: !0, writable: !1});
        Object.defineProperty(this, '$modalErrorPopup', { enumerable: !1, value: $('.fr-modal-alert'), configurable: !0, writable: !1 });
        Object.defineProperty(this, 'operationDefferTime', {enumerable: !1, value: 50, configurable: !0, writable: !1});

        this._initServices();
        this.loadProducts();        
        this._addPersonaToPageDataAnalytics(personaId);

        window.utag_cfg_ovrd = window.utag_cfg_ovrd || {};
        window.utag_cfg_ovrd.noview = true;

        eventManager.subscribe("Sage:CartCalculated", this.followCardChanges, this);
        eventManager.subscribe("Sage:PushProduct", this.pushProduct, this);
        eventManager.subscribe("Sage:ExternalApiError", this.showErrorModal,this);
        eventManager.subscribe("Sage:PopProduct", this.popProduct, this);

        ko.applyBindings(this, scope);
    }

    ProductsCollectionComponent.prototype.loadProducts = function getProducts() {
        this.productsService.getProducts(this.personaId).then((function (productsObj) {
            if (productsObj == undefined || (productsObj != null && 'products' in productsObj && !(productsObj.products instanceof Array))) {
                // do nothing;
                eventManager.trigger("Sage:ExternalApiError");
                console.error("no product");
                return;
            }

            // cleanup old results
            this.products.removeAll();
            productsObj.products.forEach(function (el) {
                el.quantity = ko.observable(+(el.productPreselection === !0));
                el.quantity.subscribe(this._selectionChanged.bind(this, null), this);

                el.productOptions.forEach(function (opt) {
                    opt.quantity = ko.observable((opt.productPreselection === !0 && !!opt.productDefaultQuantity) ? opt.productDefaultQuantity : 0);
                    opt.quantity.subscribe(this._selectionChanged.bind(this, el), this);
                }, this);

                // copy object to the array
                this.products.push(el);
                this._addProductToPageDataAnalytics(el);
            }, this);
                utag.view(window.utag_data);

        }).bind(this), function () {
            eventManager.trigger("Sage:ExternalApiError");               
        }).then((function() {
            return shoppingCartService.getProductCart(this.personaId);
        }).bind(this))
        .then((function(prevCart){
            if(!prevCart || !('value' in prevCart) || !('products' in prevCart.value) || !prevCart.value.products instanceof Array) return;

            return this.followCardChanges(prevCart.value);
        }).bind(this))
        .then((function() {
            if(!this.products() || this.products().length <= 0) { return; }

            var selectedProducts = this.products().slice().filter(function(p) { return +p.quantity() > 0; });
            if(selectedProducts.length > 0) {
                // preselected
                this._selectionChanged(selectedProducts[0]);
            }

        }).bind(this));
    }

    ProductsCollectionComponent.prototype._addPersonaToPageDataAnalytics = function _addPersonaToPageDataAnalytics(personaId) {
        var data = {
            persona_id: [personaId]          
        };
        tealium.appendPageData(data);
    }

    ProductsCollectionComponent.prototype._addProductToPageDataAnalytics = function _addProductToPageDataAnalytics(product) {
        var data = {             
            //"product_id": [product.productSku],
            //"product_name": [product.productLabel],
            //"product_category": [product.parentSku],
            //"product_quantity": (typeof product.quantity === "function") ? product.quantity() : product.quantity,
            //"product_price": product.productPrice,
            //"product_discount": ["0"],
            //"product_brands": ["Sage"],
            "product_payment_cadence": product.paymentTerm,
            "product_number_of_companies": ["1"],
            "product_number_of_employees": ["1"]
        };
        tealium.appendPageData(data);
    }

    ProductsCollectionComponent.prototype.addProduct = function addProduct(product) {
        product.quantity(1);
        eventManager.trigger("Sage:AddProductEvent", product);
    }

    ProductsCollectionComponent.prototype.removeProduct = function removeProduct(product) {
        eventManager.trigger("Sage:RemoveProductEvent", product);
        product.quantity(0);
    }

    ProductsCollectionComponent.prototype.pushProduct = function pushProduct(parentSku, productSku) {
        var product = this.products().filter(function(p) {
            return p.parentSku === parentSku && p.productSku === productSku;
        });

        if(product.length) {
            this.addProduct(product[0]);
        }
    }

    ProductsCollectionComponent.prototype.popProduct = function popProduct(parentSku, productSku) {
        var product = this.products().filter(function(p) {
            return p.parentSku === parentSku && p.productSku === productSku;
        });

        if(product.length) {
            this.removeProduct(product[0]);
        }
    }

    ProductsCollectionComponent.prototype.validateNumber = function validateNumber(pOption, event) {

        var el = event.currentTarget || event.target;

        var min = +el.getAttribute('min');
        var max = +el.getAttribute('max');
        var value = +el.value.replace(/[^\d]+/g, '');

        if(min > value) {
            value = min;
        } else if(max < value) {
            value = max;
        } 

        el.value = value;
    }

    ProductsCollectionComponent.prototype.followCardChanges = function followCardChanges(cartObj) {
        if('products' in cartObj && !(cartObj.products instanceof Array)) return;


        this.products().forEach(function(prod){
            var cartProductsArr = cartObj.products.filter(function(cProd){ return cProd.parentSku === prod.parentSku && cProd.productSku === prod.productSku; });
            var cartProduct = cartProductsArr && cartProductsArr.length > 0 ? cartProductsArr[0] : null;
            
            if(cartProduct) {
                prod.quantity(cartProduct.quantity);
                prod.productOptions.forEach(function(option){
                    var cartOptionsArr = cartProduct.productOptions.filter(function(cOption){ return cOption.parentSku === option.parentSku && cOption.productSku === option.productSku; });
                    var cartOption = cartOptionsArr && cartOptionsArr.length > 0 ? cartOptionsArr[0] : null;
                    if(cartOption) {
                        // read quantity from the cart
                        option.quantity(cartOption.quantity);
                    } else {
                        // reset to the default setting
                        option.quantity(option.productDefaultQuantity);
                    }
                })
            } else {
                // reset to the default
                prod.quantity(0);
                prod.productOptions.forEach(function(option) { option.quantity(option.productDefaultQuantity); });
            }
        });

        this.$modalPopup.modal('hide')
    }

    ProductsCollectionComponent.prototype.getOptions = function getOptions(pOption) {
        if(pOption.productType != 'dropdown') {
            return [];
        }

        var options = [];
        for(var i = 1; i <= pOption.displayLimit; i++) {
            options.push({
                name: i + ' ' + pOption.unitLabel + (i > 1 ? 's' : '') + ( pOption.productDefaultQuantity == i && pOption.productIncluded != null ? ', ' + pOption.productIncluded : '' ),
                value: i
            });
        }

        return options;
    };

    ProductsCollectionComponent.prototype.stepUp = function stepUp(el, option) {
        el.stepUp();
        // trigger to recalculate the price
        option.quantity(el.value);
        if(this.numberUpdateTm) clearTimeout(this.numberUpdateTm);
        this.numberUpdateTm = setTimeout(this.selectProductCount.bind(this, el), this.operationDefferTime);
    }

    ProductsCollectionComponent.prototype.stepDown = function stepDown(el, option) {
        el.stepDown();
        // trigger to recalculate the price
        option.quantity(el.value);
        if(this.numberUpdateTm) clearTimeout(this.numberUpdateTm);
        this.numberUpdateTm = setTimeout(this.selectProductCount.bind(this, el), this.operationDefferTime);
    }

    ProductsCollectionComponent.prototype.showModalByKeyboard = function showModalByKeyboard(el, product, e) {
        if(e.keyCode !== 13) return;

        this.showModal(product, el);
    }

    ProductsCollectionComponent.prototype.showModal = function showModal(product, el) {

        pauseTheVideo(el);

        var $modalBody = this.$modalPopup.find('.modal-body');
        ko.applyBindings(product, $modalBody.get(0));

        eventManager.trigger("Sage:OpenModal", product, el);
        this.$modalPopup.modal('show').on('hidden.bs.modal', (function ($modalBody) { ko.cleanNode($modalBody.get(0)); $modalBody.empty(); }).bind(this, $modalBody))
                                        // trigger gated content to be loaded and assigned to buttons.;
                                      .on('shown.bs.modal', function() { gatedContentHelper.loadGatedContent(document.querySelector('body')); });
        this.$modalPopup.find('.modal-dialog').scrollTop(0);
        this.$modalPopup.on('hidden.bs.modal', function () { eventManager.trigger("Sage:CloseModal", product, el); });
        this.$modalPopup.get(0).focus();
        moduleLoader.loadPendingModules(this.$modalPopup.get()).then(function () { eventManager.trigger('invoke-lazy-load'); });

        var cb = (function(el, e) {if(e.keyCode !== 27) return; this.hideModal(); document.removeEventListener('keyup', cb); }).bind(this, el);
        document.addEventListener('keyup', cb)
    }

    ProductsCollectionComponent.prototype.hideModal = function hideModal() {

        this.$modalPopup.modal('hide');
    }

    ProductsCollectionComponent.prototype.showChannelSelectionDialog = function showChannelSelectionDialog(pOption, event) {
        event.preventDefault();

        var channelSelectionEl = document.querySelector('.cs-callback');
        if(channelSelectionEl) {
            this.hideEmployeesLimit(pOption, event);
            channelSelectionEl.click();
        }
    }


    ProductsCollectionComponent.prototype.canShowEmployeesLimit = function(pOption, limitNumber, numberOfEployeersSku) {
        if(!(pOption.parentSku + '|' + pOption.productSku + '__limitclosed' in this)) {
            this[pOption.parentSku + '_' + pOption.productSku + '__limitclosed'] = ko.observable(jsCookie.get(pOption.parentSku + '|' + pOption.productSku + '__limitclosed'));
        }

        return pOption.quantity() >= +limitNumber 
                && !isNaN(+limitNumber) 
                && +limitNumber > pOption.productDefaultQuantity 
                && pOption.productSku === numberOfEployeersSku 
                && !this[pOption.parentSku + '_' + pOption.productSku + '__limitclosed']();
    }

    ProductsCollectionComponent.prototype.hideEmployeesLimit = function(pOption, event) {
        if(event.type !== 'click' && (event.type !== 'keyup' || event.keyCode !== 13)) {
            return;
        }

        jsCookie.set(pOption.parentSku + '|' + pOption.productSku + '__limitclosed', !0, { path: '', expires: 7 });
        // this property is set on canShowEmployeesLimit method.
        this[pOption.parentSku + '_' + pOption.productSku + '__limitclosed'](!0);
    }

    ProductsCollectionComponent.prototype.showErrorModal = function showErrorModal() {
        this.$modalErrorPopup.modal({ show: true });
    }

    ProductsCollectionComponent.prototype.showProductHint = function showProductHint(el) {
        var $el = $(el).find('.infobox');
        if(!$el.is('.in'))  {
            $el.addClass('in');
        }

        var cb = (function(el, e) {if(e.keyCode !== 27) return; this.hideProductHint(el, null, e); document.removeEventListener('keyup', cb); }).bind(this, el);
        document.addEventListener('keyup', cb)

        var clickCb = (function(el, e){function childOf(c,p){while((c=c.parentNode)&&c!==p);return !!c}; if(childOf(e.target, el))return; this.hideProductHint(el, null, e); document.removeEventListener('click', clickCb)}).bind(this, el);
        document.addEventListener('click', clickCb);
    }

    ProductsCollectionComponent.prototype.hideProductHint = function hideProductHint(el, product, event) {
        if(event.type !== 'click' && (event.type !== 'keyup' || event.keyCode !== 13)) {
            return;
        }

        var $el = $(el).find('.infobox');
        if($el.is('.in'))  {
            $el.removeClass('in');
        }
    }

    ProductsCollectionComponent.prototype.formatProductHint = function formatProductHint(productHint, el) {
        return productHint.map(function (v) {
            return v.replace(/\#\#\#/gi, '<br/>');
        }).join('<br/><br/>');
    }

    ProductsCollectionComponent.prototype._selectionChanged = function(product) {
        
        // don't track changes of an unselected product
        if(product != null && product.quantity() <= 0) return;

        // read the state from the browser
        var selectedProducts = this.products().slice().filter(function(p) { return +p.quantity() > 0; });

        selectedProducts = selectedProducts.map(function(p) {
            var cleanProduct = JSON.parse(JSON.stringify(p));
            cleanProduct.quantity = p.quantity();
            cleanProduct.productOptions = p.productOptions.filter(function(o) {return +o.quantity() > 0;}).map(function (o){
                var cleanOption = JSON.parse(JSON.stringify(o));
                cleanOption.quantity = o.quantity();
                return cleanOption;
            });

            return cleanProduct;
        })
        
        if(this.antiFlood_selectionChangedTm) clearTimeout(this.antiFlood_selectionChangedTm);

        this.antiFlood_selectionChangedTm = setTimeout((function(selectedProducts){
            // send to calculate the price
            this.calculationPromise = this.calculationPromise 
                                            ? this.calculationPromise.then(shoppingCartService.calculateCart.bind(shoppingCartService, { 'products': selectedProducts }))
                                            : shoppingCartService.calculateCart({ 'products': selectedProducts });

        }).bind(this, selectedProducts), this.operationDefferTime);
    }

    ProductsCollectionComponent.prototype.selectProductCount = function (el) {       
        var $el = $(el);
        var eventObj = bodySelectEvent.GenerateEventMetadata($el, $(el).val());
        tealium.event(eventObj);
    }

    ProductsCollectionComponent.prototype._initServices = function _initServices() {

        var productsService = new productsServiceCtor(this.extProdApiDomain, this.extProdApiKey, this.marketId, this.langName);
        Object.defineProperty(this, 'productsService', { enumerable: !1, value: productsService, configurable: !0, writable: !0 });
    }

    ProductsCollectionComponent.prototype._prepareModalPopup = function _prepareModalPopup() {
        return $(this.scope).next('.modal').appendTo('body');
    }



    ProductsCollectionComponent.init = function ProductsCollectionComponentInit(args) {
        return args.IsEditorEditing === true
            ? null
            : new ProductsCollectionComponent(args.scope, args.PersonaID, args.ExternalProductsServiceHost, args.ExternalServiceApiKey, args.MarketItemID, args.Lang);
    };

    function pauseTheVideo(el) {
        var $videoEl = $(el).closest(".score-style-box").find(".sage-video-component");
        if ($videoEl.length) {
            var $videoIframes = $videoEl.find("iframe");
            if ($videoIframes.length) {
                $videoIframes[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
            }
        }
    }

    return ProductsCollectionComponent;
}));


